import { render, staticRenderFns } from "./ContactAddressCategorySelect.vue?vue&type=template&id=009c4dfa"
import script from "./ContactAddressCategorySelect.vue?vue&type=script&lang=js"
export * from "./ContactAddressCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports